import { DocumentStatus } from 'modules/Documents/models/document';
import { StatusInfo } from 'modules/Documents/models/statusInfo';
import { VerifactuInvoiceType } from 'modules/Documents/models/verifactuInvoice';

export const normalizeVerifactuInvoiceTypeToStatusInfo = (
  type: VerifactuInvoiceType,
  status: DocumentStatus
) => {
  if (type === VerifactuInvoiceType.Test) {
    return StatusInfo.TEST;
  }
  if (status === DocumentStatus.VOID) {
    return StatusInfo.VOID;
  }
  return StatusInfo.ISSUED;
};
